import { dateToDateOnlyApiFormat } from '@/helpers/dateHelper';
import { useUpcomingLeaveRequestsByEmployeeIdQuery } from '../gql/graphql.generated';

export const useUpcomingLeaveRequests = (employeeId: string) => {
  const today = dateToDateOnlyApiFormat(new Date());

  const [result, refetch] = useUpcomingLeaveRequestsByEmployeeIdQuery({
    variables: { id: employeeId!, today },
    pause: !employeeId,
    requestPolicy: 'network-only'
  });

  return {
    requests: result.data?.upcomingLeaveRequestsByEmployeeId ?? [],
    refetch
  };
};
